export default "__VITE_ASSET__ba48be78__"